import { gql, useQuery } from "@apollo/client";
import Button, { CharlesButtonWithArrow } from "components/base/Button";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";
import ChooseFolderImagesView from "./ChooseFolderImagesView";

const FETCH_ONE_DRIVE_PRODUCTS = gql`
  query FETCH_ONE_DRIVE_PRODUCTS {
    oneDriveChildren(path: "wis/beautyshots/wis")
  }
`;

const ChooseImagesFromOneDriveView = ({ onSave }) => {
  const { loading, error, data } = useQuery(FETCH_ONE_DRIVE_PRODUCTS);
  const [searchText, setSearchText] = useState("");
  const [selectedFolders, setSelectedFolders] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  function onClickImage(id) {
    setSelectedImages((prev) => {
      if (prev.map((i) => i.id).includes(id)) {
        return prev.filter((i) => i.id !== id);
      } else {
        return [...prev, { id }];
      }
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.oneDriveChildren).value;

  const products = res
    .filter((i) => searchByProp(i, ["name"], searchText))
    .filter((i) => i.folder && i.folder.childCount > 0);

  return (
    <div className="overflow-auto flex flex-col m-10 mt-4 text-sm">
      <div className="sticky top-0 bg-gray-100 pb-2 z-10">
        <SearchBar
          className="dark:bg-gray-900"
          placeholder="Search by name"
          text={searchText}
          onChange={setSearchText}
        />
      </div>
      <div className="flex-1">
        {products.map((i) => (
          <div key={i.id} className="py-2 border-b dark:border-gray-700">
            <CharlesButtonWithArrow
              show={selectedFolders.includes(i.id)}
              onClick={() =>
                setSelectedFolders((prev) => {
                  if (prev.includes(i.id)) {
                    return prev.filter((id) => id !== i.id);
                  } else {
                    return [...prev, i.id];
                  }
                })
              }
            >
              {i.name} ({i.folder ? i.folder.childCount : 0})
            </CharlesButtonWithArrow>

            {selectedFolders.includes(i.id) && (
              <div className="mt-2">
                <ChooseFolderImagesView
                  oneDriveFolderId={i.id}
                  value={selectedImages.map((i) => i.id)}
                  onClick={onClickImage}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="sticky bottom-0 bg-gray-100 pt-4 space-y-2">
        <div className="text-xs opacity-70">
          {selectedImages.length} images selected
        </div>
        <Button primary onClick={() => onSave(selectedImages)}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default ChooseImagesFromOneDriveView;
